import { useContext, useEffect } from "react";
import { createContext, useState } from "react";
import { UserService } from "../services";
import { TOKEN } from "../services/http";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Spinner } from "react-bootstrap";


const LoaderContext = createContext({});

const defaultDetails = {
    _id: "",
    name: "",
    mobile: "",
    profile: ""
}

const UserProvider = ({ children }) => {
    const [user, setUserData] = useState(defaultDetails);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [enable, setEnable] = useState(false);
    const { userProfile } = UserService();
    const fetchData = useQuery({
        queryKey: ['userProfile'],
        queryFn: async () => userProfile({
            token: TOKEN
        }),
        enabled: enable
    });

    useEffect(() => {
        if (fetchData?.data?.data?.user) {
            setUser(fetchData.data?.data?.user)
        } else if (fetchData.error?.status === 401) {
            logout()
        } else if (fetchData.isError) {
            setLoading(false);
        }
    }, [fetchData.isPending]);

    const setUser = (data) => {
        if (data) {
            setUserData(prev => ({ ...prev, ...data }));
            setLoading(false);
        } else if (data === null) {
            setUserData(defaultDetails);
        }
    }

    const isLoggedIn = user._id.length ? true : false;

    const logout = () => {
        setLoading(false);
        setUserData(defaultDetails);
        localStorage.removeItem("hollypills_token");
        navigate("/");
    }

    useEffect(() => {
        if (TOKEN) {
            setEnable(true);
        } else {
            setLoading(false);
        }
    }, []);

    return (
        <LoaderContext.Provider value={{ user, setUser, isLoggedIn, logout }}>
            {
                loading
                    ?
                    <div style={{ width: "100%", height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                        <Spinner animation="border" role="status" variant="primary"></Spinner>
                        <div>
                            Loading...
                        </div>
                    </div>
                    :
                    children
            }
        </LoaderContext.Provider>
    );
};

const useUser = () => useContext(LoaderContext);

export default useUser;
export { UserProvider };